import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { EditableGridService, SystemApiService } from '@cv-invision/core';
import { CIJobTypeModel } from '../model/ci-job-types.model';

@Injectable({ providedIn: 'root' })
export class CIJobTypesService extends EditableGridService {

	private setReloadlListConfirmation = new BehaviorSubject({});
	private getReloadlListListener = this.setReloadlListConfirmation.asObservable();

	constructor(private httpClient: HttpClient, private systemApiService: SystemApiService) {
		super();
	}

	/**
	 * PUT - Save the configuration.
	 */
	saveAppScopeCIJobTypesConfiguration(config: Array<CIJobTypeModel>): Observable<any> {
		return this.httpClient.put(
			`${this.systemApiService.api.orders}/class-intelligence/auto-import/product-types`, config);
	}

	/**
	 * GET - Return the list of the App Scope CI Job Types configuration mappings.
	 */
	getAppScopeCIJobTypesConfiguration(): Observable<any> {
		return this.httpClient.get(
			`${this.systemApiService.api.orders}/class-intelligence/auto-import/product-types`);
	}

	/**
	 * Sets component data communication.
	 * @param data
	 */
	setReloadListConfirmation(data: any): void {
		this.setReloadlListConfirmation.next(data);
	}

	/**
	 * Returns if the list should be reloaded.
	 */
	getReloadListConfirmationListener(): Observable<any> {
		return this.getReloadlListListener;
	}
}
